import { cn } from "@newxsystems/shared";
import type { ITeamGridBlockProps } from "./TeamGridBlock.props";
import { TootActions } from "../../../../modules/layout/components/TootActions/TootActions";
import { TootHeading } from "../../../../modules/layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import { TootPersonCard } from "../../../../modules/people/components/TootPersonCard/TootPersonCard";
import { TootTechPanel } from "../../../../modules/surface/components/TootTechPanel/TootTechPanel";

export const TeamGridBlock = ({
  anchorId,
  buttons,
  eyebrow,
  heading,
  members,
  parentClass,
  spacing,
  subheading,
}: ITeamGridBlockProps) => {
  const hasHeader = Boolean(eyebrow || heading || subheading || buttons?.length);

  if (!hasHeader && !members?.length) {
    return null;
  }

  return (
    <TootSectionShell
      actions={buttons?.length ? <TootActions actions={buttons} alignment="left" /> : undefined}
      className="relative"
      header={
        hasHeader ? (
          <TootHeading
            alignment="left"
            eyebrow={eyebrow ?? undefined}
            heading={heading ?? undefined}
            inverse
            subheading={subheading ?? undefined}
          />
        ) : undefined
      }
      id={anchorId ?? undefined}
      rootClassName={cn("relative overflow-hidden", parentClass)}
      spacing={spacing ?? undefined}
      tone="dark"
      width="wide"
    >
      <TootTechPanel className="toot-heat-panel" showDividers={false} variant="proof">
        {members?.length ? (
          <div className="grid gap-5 xl:gap-6">
            <div className="grid min-w-0 grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 xl:gap-5">
              {members.map((member, index) => (
                <TootPersonCard
                  bio={member.shortBio}
                  className="h-full"
                  contactLinks={[
                    ...(member.email
                      ? [{ href: `mailto:${member.email}`, label: member.email }]
                      : []),
                    ...(member.phone
                      ? [
                          {
                            href: `tel:${member.phone.replace(/[^+\d]/g, "")}`,
                            label: member.phone,
                          },
                        ]
                      : []),
                  ]}
                  department={member.department ?? undefined}
                  image={member.image}
                  key={`${member.name}-${member.role}-${index}`}
                  location={member.location ?? undefined}
                  name={member.name}
                  pronouns={member.pronouns ?? undefined}
                  role={member.role}
                  socialLinks={(member.socialLinks ?? []).map((link) => ({
                    ariaLabel: link.ariaLabel,
                    href: link.href,
                    label: link.text,
                    target: link.target,
                  }))}
                />
              ))}
            </div>
          </div>
        ) : null}
      </TootTechPanel>
    </TootSectionShell>
  );
};

TeamGridBlock.displayName = "Block::TeamGridBlock";
